module.exports = __webpack_public_path__ + "static/media/filter-list.3957508b.svg";